import * as storage from './storage';
import store from '../store';
import oss from './oss';

function showMessage(message) {
    return new Promise(((resolve) => {
        store.commit('SET_GLOBAL_MESSAGE', {message, resolve});
    }));
}

function fileNameValid(src, types) {
    return types.reduce((t, ty) => {
        if (typeof (t) === 'string') {
            t = src.endsWith(t);
        }
        return t || src.endsWith(ty);
    })
}

function setTitle(title) {
    document.title = title;
}

export {
    showMessage,
    fileNameValid,
    setTitle,
    storage,
    oss
}
